import { FC } from "react";
import {
  InformationBox,
  MuiButtonPrimary,
  MuiButtonTertiary,
  MuiGrid,
  MuiOptionMenu,
  MuiTypography,
} from "../../../../components";
import { CreateClientHeaderWrapper } from "./CreateClientHeader.style";
import { useSiteCore } from "../../../../hooks/useSiteCore";
import {
  createClientSelector,
  editClientSelector,
} from "../../../../redux/slices/client/createClientSelector";
import { useSelector } from "react-redux";
import { createClientSiteCoreKeys } from "../../siteCore/SiteCoreKeys";
import { ReactComponent as HierarchyIcon } from "../../../../assets/images/hierarchy.svg";
import { isRetailClient } from "../../../../helpers/utils";
import { useNavigationSiteCore } from "../../../../hooks/useNavigationSiteCore";
import { useMediaQueries } from "../../../../hooks/useMediaQueries";
import { LabelWithIconText } from "../../../../styles/common.style";
import PermissionWrapper from "../../../../components/permissionWrapper/PermissionWrapper";
import { MODULE_PERMISSIONS } from "../../../../helpers/constants";

interface CreateClientHeaderProps {
  onViewHierarchyClick?: () => void;
  onEditClientClick?: () => void;
  isViewClient?: boolean;
  isEditableForCountry?: boolean;
}
export const CreateClientHeader: FC<CreateClientHeaderProps> = ({
  onViewHierarchyClick,
  onEditClientClick,
  isViewClient = false,
  isEditableForCountry = false,
}) => {
  const { pageTitle, fetchLabel, commonLabels } = useSiteCore();
  const { commonARIALabel } = useNavigationSiteCore();
  const { isEdit } = useSelector(editClientSelector);
  const clientData = useSelector(createClientSelector);

  const gridSize = { sm: 6, xs: 12 };

  const { isMobile } = useMediaQueries();
  const hierarchyOptions = [
    {
      onClick: () => onViewHierarchyClick?.(),
      dataTestId: "view-hierarchy-button",
      className: "header-view-hierarchy",
      label: (
        <LabelWithIconText>
          <HierarchyIcon />
          {commonARIALabel.viewHierarchy}
        </LabelWithIconText>
      ),
    },
  ];
  return (
    <CreateClientHeaderWrapper>
      <MuiGrid
        container
        className="create-client-header-container"
        id="create-client-header-container"
      >
        <MuiGrid
          size={gridSize}
          className="header-left"
          data-testid={"header-left"}
        >
          <InformationBox
            title={
              isViewClient
                ? fetchLabel(
                    createClientSiteCoreKeys.createClientHeader,
                    createClientSiteCoreKeys.viewClientHeading,
                  )
                : isEdit
                  ? fetchLabel(
                      createClientSiteCoreKeys.createClientHeader,
                      createClientSiteCoreKeys.editClientHeading,
                    )
                  : pageTitle
            }
          />
        </MuiGrid>
        {(isEdit || isViewClient) && (
          <MuiGrid
            size={gridSize}
            className="header-right"
            data-testid={"header-right"}
          >
            {!isRetailClient(clientData.clientTypeId) &&
              (isMobile ? (
                <MuiOptionMenu
                  className="header-view-hierarchy"
                  menuItems={hierarchyOptions}
                />
              ) : (
                <MuiButtonTertiary
                  id={"view-hierarchy-button"}
                  onClick={onViewHierarchyClick}
                  className="header-view-hierarchy"
                  aria-label={commonARIALabel.viewHierarchy}
                >
                  <MuiTypography className="hierarchyIcon">
                    <HierarchyIcon />
                  </MuiTypography>
                  {fetchLabel(
                    createClientSiteCoreKeys.createClientHeader,
                    createClientSiteCoreKeys.viewHierarchyLinkText,
                  )}
                </MuiButtonTertiary>
              ))}

            {isViewClient && !isMobile && (
              <PermissionWrapper
                hasCountryLevelAccess={isEditableForCountry}
                permission={MODULE_PERMISSIONS.EDIT_CLIENT}
              >
                <MuiButtonPrimary
                  className="header-edit-client"
                  onClick={onEditClientClick}
                >
                  {commonLabels.edit}
                </MuiButtonPrimary>
              </PermissionWrapper>
            )}
          </MuiGrid>
        )}
      </MuiGrid>
      {isViewClient && isMobile && (
        <PermissionWrapper
          checkCountryLevelAccessOnly
          hasCountryLevelAccess={isEditableForCountry}
        >
          <MuiButtonPrimary
            className="header-edit-client"
            onClick={onEditClientClick}
          >
            {commonLabels.edit}
          </MuiButtonPrimary>
        </PermissionWrapper>
      )}
    </CreateClientHeaderWrapper>
  );
};
